import axios from 'axios';

import config from '../config';
import { validateToken } from '@utils/isTokenExpired';

import { ExportSubscriptionPngResponse, ImageryFavoritesResponse } from '@mytypes/imagery';

export const getImageryFavoritesApi = async (payload: {
  field_id: string;
  client_id: string;
  trial_id: string;
  protocol_id: string;
}): Promise<ImageryFavoritesResponse | undefined> => {
  try {
    if (!(await validateToken())) {
      return;
    }

    const params = new URLSearchParams();

    params.append('client_id', payload.client_id);
    params.append('trial_id', payload.trial_id);
    params.append('field_id', payload.field_id);
    params.append('protocol_id', payload.protocol_id);

    const { data } = await axios.post(`${config.REACT_APP_IMAGERY_SERVICE_URL}/status-favorites`, params, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    });

    return data as ImageryFavoritesResponse;
  } catch (error) {
    console.log(error);
  }
};

export const imageExportSubscriptionPng = async ({ id, index_type = 'NDRE' }: { id: string; index_type?: string }) => {
  const params = new URLSearchParams();
  params.append('id', id);
  params.append('index_type', index_type);

  const { data } = await axios.post(`${config.REACT_APP_IMAGERY_SERVICE_URL}/export-subscription`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }
  });

  return data as ExportSubscriptionPngResponse;
};
